import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";

// Rotates the newest 5-star Google reviews as a quote under the hero copy.
export default function HeroReviewQuote({ data }) {
  const quotes = (data?.enabled && Array.isArray(data?.reviews) ? data.reviews : []).filter(r => (r.rating || 0) >= 5 && (r.text || "").trim()).slice(0, 5);
  const [i, setI] = useState(0);
  const [show, setShow] = useState(true);
  useEffect(() => {
    if (quotes.length < 2) return;
    const t = setInterval(() => { setShow(false); setTimeout(() => { setI(x => (x + 1) % quotes.length); setShow(true); }, 500); }, 7000);
    return () => clearInterval(t);
  }, [quotes.length]);
  if (!quotes.length) return null;
  const q = quotes[i];
  const text = q.text.length > 160 ? q.text.slice(0, 157).trimEnd() + "…" : q.text;
  return (
    <div className={`mt-10 max-w-xl border-l-2 border-red-600 pl-4 transition-opacity duration-500 ${show ? "opacity-100" : "opacity-0"}`} data-testid="hero-review-quote">
      <div className="flex gap-0.5 text-red-500 mb-2">{[1, 2, 3, 4, 5].map(n => <Star key={n} size={12} fill="currentColor" />)}</div>
      <p className="text-zinc-200 italic leading-relaxed" data-testid="hero-review-text">“{text}”</p>
      <div className="text-zinc-500 text-xs mt-2 uppercase tracking-widest" data-testid="hero-review-author">— {q.author_name} · Google review</div>
    </div>
  );
}
